// libs
import { css } from "@emotion/core";
import styled from "@emotion/styled";

// global components
import BaseImage from "shared/components/Image";

// constants
import {
    BANNER_SHADOW_HOVER,
    DWEB_MAX_WIDTH,
    FONTS,
    COLORS,
    BASE_GUTTER_SPACE,
} from "shared/styles/base";
import { truncate } from "styles/mixin";
import { MARGIN_RIGHT } from "shared/components/AdPlatformWidgets/Desktop/constant";

// mixins
import { getColumnDimension } from "shared/components/AdPlatformWidgets/Desktop/mixin";

const CardCss = css`
    display: inline-block;
    max-width: ${DWEB_MAX_WIDTH}px;
    width: auto;
    margin: 0 ${MARGIN_RIGHT}px 10px 0;
    border-radius: 3px;
    text-align: center;
    line-height: 0;

    &.textOverImage {
        .desc {
            width: 100%;
            position: absolute;
            top: 0;
            text-align: left;
            color: #fff;
        }
    }
`;

export const Anchor = styled.a<{ numOfColumns: number }>`
    ${CardCss}

    transition: box-shadow 0.3s ease;
    text-decoration: none;

    ${({ numOfColumns }) => getColumnDimension(numOfColumns)}

    &:hover {
        box-shadow: ${BANNER_SHADOW_HOVER};
    }
`;

export const Section = styled.div<{ numOfColumns: number }>`
    ${CardCss}

    ${({ numOfColumns }) => getColumnDimension(numOfColumns)}
`;

export const Title = styled.p<{ textColor: string }>`
    ${truncate}
    display: block;
    color: ${props => props.textColor};
    font: 500 1.286rem/1.5 ${FONTS.CERA};
    margin-top: ${BASE_GUTTER_SPACE}px;
    text-align: left;
`;

export const Info = styled.p<{ textColor: string }>`
    display: block;
    font: 1.143rem/1.25 ${FONTS.CERA};
    margin-top: ${BASE_GUTTER_SPACE}px;
    text-align: left;
    ${({ textColor }) => `
        color: ${textColor ? textColor : COLORS.BLACK_64};
    `}
`;

export const ImagePlaceholder = styled.div<{
    bgColor: string;
    aspectRatio: number;
}>`
    display: inline-block;
    max-width: 100%;
    width: 100%;

    ${({ bgColor, aspectRatio }) => `
        background-color: ${bgColor};
        padding-top: ${100 / aspectRatio}%;
    `}
`;

export const Image = styled(BaseImage)`
    max-width: 100%;
`;
